// frontend/src/components/CookieBanner.jsx
// Bandeau localStorage/cookies — affiché une seule fois, après la WelcomeModal.
import { useState, useEffect } from "react";

const COOKIES_KEY = "crushnow_cookies_seen";
const WELCOME_KEY = "crushnow_welcome_seen";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Déjà vu — ne jamais afficher
    if (localStorage.getItem(COOKIES_KEY)) return;

    // WelcomeModal déjà fermée — afficher immédiatement
    if (localStorage.getItem(WELCOME_KEY)) {
      setVisible(true);
      return;
    }

    // WelcomeModal pas encore vue — attendre qu'elle soit fermée
    const interval = setInterval(() => {
      if (localStorage.getItem(WELCOME_KEY)) {
        clearInterval(interval);
        if (!localStorage.getItem(COOKIES_KEY)) {
          setVisible(true);
        }
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIES_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0, left: 0, right: 0,
      background: "white",
      borderTop: "1px solid #e2e8f0",
      padding: "16px 20px 80px",
      zIndex: 9999,
      boxShadow: "0 -4px 12px rgba(0,0,0,0.08)"
    }}>
      <p style={{ fontSize: "12px", color: "#475569", marginBottom: "12px", lineHeight: "1.6" }}>
        🍪 <strong>Stockage local</strong> — CrushNow utilise le stockage local de votre appareil
        pour maintenir votre session, mémoriser vos préférences (géolocalisation, notifications)
        et améliorer votre expérience. Aucun cookie publicitaire. Aucune donnée revendue.{" "}
        <a href="/privacy" style={{ color: "#e11d48", textDecoration: "underline" }}>
          En savoir plus
        </a>
      </p>
      <div style={{ display: "flex", gap: "8px" }}>
        <button
          onClick={handleAccept}
          style={{
            flex: 1, padding: "10px", borderRadius: "8px", border: "none",
            background: "#e11d48", color: "white", fontWeight: 700,
            fontSize: "13px", cursor: "pointer"
          }}
        >
          ✅ J'ai compris
        </button>
        <a
          href="/privacy"
          style={{
            padding: "10px 14px", borderRadius: "8px", border: "1px solid #e2e8f0",
            background: "white", color: "#475569", fontWeight: 600,
            fontSize: "13px", cursor: "pointer", textDecoration: "none",
            display: "flex", alignItems: "center"
          }}
        >
          En savoir plus
        </a>
      </div>
    </div>
  );
}
